export var MessageEventType = {
  START: 'start',
  STOP: 'stop'
};
export var MessageDeliveryStatus = {
  BLOCKED: 'blocked',
  CANCELED: 'canceled',
  ERROR: 'error',
  STARTED: 'started',
  STOPPED: 'stopped',
  UNREGISTERED: 'unregistered'
};
export var ProductIds = /*#__PURE__*/function (ProductIds) {
  ProductIds["CONFLUENCE"] = "confluence";
  ProductIds["ENGAGEKIT"] = "Engagekit";
  ProductIds["INTERCOM"] = "intercom";
  ProductIds["JIRA"] = "jira";
  ProductIds["PENDO"] = "pendo";
  ProductIds["CLOUDADMIN"] = "cloudadmin";
  ProductIds["BITBUCKET"] = "bitbucket";
  ProductIds["POST_OFFICE"] = "post-office";
  return ProductIds;
}({});
export var MessageTypesEnum = {
  ENGAGEMENT: 'engagement',
  MARKETING: 'marketing',
  TRANSACTIONAL: 'transactional'
};
export var IntegratedChoreographerMessageTypesEnum = [MessageTypesEnum.ENGAGEMENT, MessageTypesEnum.MARKETING];
export var MessageAction = {
  START: 'messageStart',
  STOP: 'messageStop'
};
export var LoggingLevel = {
  INFO: 'info',
  VERBOSE: 'verbose'
};